<template>
  <div>
    <div id="printMeBarcodeAll">
      <table v-if="selectedRow">
        <tr v-for="(ssvalue, ssindex) in selectedRow.KoliBarcodesNumber" :key="ssindex">

          <table class="custom-table">
            <tr>
              <th class="border-item"
                style="padding: 12px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">
                GÖNDEREN/ALICI</th>
              <td class="border-item"
                style="padding: 12px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">
                DENİZLİ
                CONCEPT / {{ selectedRow.program || '' }}</td>
            </tr>
            <tr>
              <th class="border-item"
                style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">
                Ürün
                Adı
              </th>
              <td class="border-item"
                style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">{{
                  selectedRow.productName || '' }}</td>
            </tr>
            <tr>
              <th class="border-item"
                style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">
                Sipariş
                No</th>
              <td class="border-item"
                style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">{{
                  selectedRow.orderNumber || '' }}</td>
            </tr>
            <tr>
              <th class="border-item"
                style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">
                Sipariş
                Tarihi</th>
              <td class="border-item"
                style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">{{
                  formatTarih(selectedRow.siparisTarihi) || '' }}</td>
            </tr>
            <tr>
              <th class="border-item"
                style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">
                Adet
              </th>
              <td class="border-item"
                style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">{{
                  selectedRow.KoliAdet || '' }}</td>
            </tr>


            <tr>
              <th class="border-item"
                style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 85px; font-weight: bold;">
                Koli
                No
              </th>
              <td class="border-item"
                style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 85px; font-weight: bold;">
                <h6 style="font-size: 85px;">{{ ssvalue }}</h6>
              </td>

            </tr>
            <tr style="height: 75px;">

            </tr>
            <tr v-if="barcodeData && barcodeData.length">
              <td class="border-item barcode-container" colspan="2">
                <div style="width: 100%; height: auto;">
                  <barcode :value="selectedRow.barcode" format="CODE128" tag="svg" :width="8" :height="400"
                    :text-options="{ fontSize: 1000 }" style="width: 100%; height: auto;" />
                  <h1 style="text-align: center;font-size: 65px;"> {{ selectedRow.barcode }}</h1>
                </div>
              </td>
            </tr>
            <tr style="height: 100px;">

            </tr>


          </table>
          
        </tr>

      </table>

      <div class="" style=""></div>
    </div>
    <div id="printMeBarcode">

      <table class="custom-table" v-if="selectedRow">
        <tr>
          <th class="border-item"
            style="padding: 12px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">
            GÖNDEREN/ALICI</th>
          <td class="border-item"
            style="padding: 12px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">
            DENİZLİ
            CONCEPT / {{ selectedRow.program || '' }}</td>
        </tr>
        <tr>
          <th class="border-item"
            style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">
            Ürün
            Adı
          </th>
          <td class="border-item"
            style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">{{
              selectedRow.productName || '' }}</td>
        </tr>
        <tr>
          <th class="border-item"
            style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">
            Sipariş
            No</th>
          <td class="border-item"
            style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">{{
              selectedRow.orderNumber || '' }}</td>
        </tr>
        <tr>
          <th class="border-item"
            style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">
            Sipariş
            Tarihi</th>
          <td class="border-item"
            style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">{{
              formatTarih(selectedRow.siparisTarihi) || '' }}</td>
        </tr>
        <tr>
          <th class="border-item"
            style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">
            Adet
          </th>
          <td class="border-item"
            style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 50px; font-weight: bold;">{{
              selectedRow.KoliAdet || '' }}</td>
        </tr>


        <tr>
          <th class="border-item"
            style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 85px; font-weight: bold;">
            Koli
            No
          </th>
          <td class="border-item"
            style="padding: 8px; border: 1px solid black; border-radius: 5px; font-size: 85px; font-weight: bold;">
            <h6 style="font-size: 85px;">{{ koliNumber }}</h6>
          </td>

        </tr>
        
        <tr v-if="barcodeData && barcodeData.length" style="margin-top: 150px; ">
          <td class="border-item barcode-container" colspan="2">
            <div style="width: 100%; height: auto;">
              <barcode :value="selectedRow.barcode" format="CODE128" tag="svg" :width="8" :height="400"
                :text-options="{ fontSize: 1000 }" style="width: 100%; height: auto;" />
              <h1 style="text-align: center;font-size: 65px;"> {{ selectedRow.barcode }}</h1>
            </div>
          </td>
        </tr>


      </table>
      
      <div class="" style=""></div>
    </div>
  </div>
</template>

<script>
import Barcode from 'vue-barcode';

export default {
  data() { return {} },
  props: {
    barcodeData: {
      type: Array,
      default: () => [],
    },
    koliNumber: "",
    selectedRow: Object,
  },
  components: {
    Barcode,
  },
  methods: {
    formatTarih(tarih) {
      if (typeof tarih !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(tarih)) {
        return tarih;
      }

      const tarihObjesi = new Date(tarih);
      const formatliTarih = `${tarihObjesi.getDate()}.${tarihObjesi.getMonth() + 1}.${tarihObjesi.getFullYear()} `;

      return formatliTarih;
    },
    created() {
      console.log(this.barcodeData)
    },
    yazdirAll() {
      setTimeout(this.yazdirBekleAll, 1000);
    },
    yazdirBekleAll() {
      this.$htmlToPaper("printMeBarcodeAll");
    },
    yazdir(index) {
      setTimeout(this.yazdirBekle, 1000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMeBarcode");
    },
    getBarcodeHeader(index) {

      return `Koli Numarası:  ${index + 1}`;

    },
  },
};
</script>

<style scoped>
.custom-table {
  width: 200%;
  max-width: 335vw;
  border-collapse: collapse;
  margin: auto;
  display: none;
}

.barcode-container text {
  font-size: 100px !important;
  /* Adjust the font size as needed */
}
</style>
